/** אימוג'י לפי שם המאכל — התאמת מילות מפתח בעברית, הכלל הראשון שמתאים מנצח.
 *  הסדר חשוב: ספציפי לפני כללי ("תפוח אדמה" לפני "תפוח"). */
const RULES: Array<[RegExp, string]> = [
  [/שקשוקה|ביצ|חביתה|אומלט/, '🍳'],
  [/קרקר|פריכ|פריכיות/, '🍘'],
  [/לחם|פיתה|בגט|טוסט|לחמני|חלה|ג'בטה/, '🍞'],
  [/שניצל|עוף|חזה|הודו|פרגית/, '🍗'],
  [/בשר|בקר|סטייק|קציצ|המבורגר|כבד|טחון/, '🥩'],
  [/סלמון|טונה|דג|אמנון|בורי|לברק|מושט/, '🐟'],
  [/אורז/, '🍚'],
  [/פסטה|ספגטי|נודלס|אטרי|פתיתים|קוסקוס/, '🍝'],
  [/פיצה/, '🍕'],
  [/תפוח אדמה|תפו"א|בטטה|צ'יפס/, '🥔'],
  [/עגבני/, '🍅'],
  [/גזר/, '🥕'],
  [/אבוקדו/, '🥑'],
  [/סלט|ירקות|חסה|מלפפון|כרוב|ברוקולי|קישוא|פלפל|בצל|תרד/, '🥗'],
  [/תפוח/, '🍎'],
  [/בננה/, '🍌'],
  [/תות/, '🍓'],
  [/ענב/, '🍇'],
  [/אבטיח/, '🍉'],
  [/מלון|מנגו|אפרסק|נקטרינ|שזיף|משמש/, '🍑'],
  [/תפוז|קלמנטינ|מנדרינ|אשכולית|לימון/, '🍊'],
  [/יוגורט|חלב|קוטג|גבינ|לבנה|שמנת|מעדן|סקיר|פרו\b/, '🥛'],
  [/קפה|הפוך|אספרסו|נס\b/, '☕'],
  [/\bתה\b/, '🍵'],
  [/מיץ|קולה|סודה|לימונדה|משקה/, '🥤'],
  [/שוקולד|עוגה|עוגי|גלידה|ממתק|וופל|קינוח|סוכרי|דונאט|קרואסון|בראוני/, '🍫'],
  [/במבה|ביסלי|חטיף/, '🥨'],
  [/אגוז|שקד|בוטן|קשיו|פיסטוק|גרעינ/, '🥜'],
  [/חומוס|טחינה|פלאפל/, '🧆'],
  [/מרק/, '🍲'],
  [/דגנ|קורנפלקס|גרנולה|שיבולת|מוזלי|קוואקר/, '🥣'],
  [/טבעול|טופו|סויה|עדשים|קטנ|שעועית|אפונה/, '🌱'],
  [/שמן|חמאה|מיונז/, '🧈'],
  [/דבש|ריבה|סילאן|מייפל/, '🍯'],
  [/פרי|פירות/, '🍎'],
];

export function foodEmoji(name: string, fallback = '🍽️'): string {
  for (const [re, em] of RULES) if (re.test(name)) return em;
  return fallback;
}

/** רשימת האייקונים לבורר הידני — בדיוק אלה שהניחוש האוטומטי כבר יודע להפיק, בלי כפילויות
 *  (למשל 🍎 מופיע פעמיים ב-RULES — "תפוח" ו"פרי/פירות"), ועם 🍽️ הכללי בסוף. */
export const FOOD_ICON_CHOICES: string[] = [...new Set(RULES.map(([, em]) => em)), '🍽️'];
